module.exports = __webpack_public_path__ + "img/baishuizhai.8fc8aa3f.jpg";